import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot", "viewport"]
  static values = { interval: { type: Number, default: 6000 }, index: { type: Number, default: 0 } }

  connect() {
    this.startX = 0
    this.show(this.indexValue)
    this.play()
  }

  disconnect() {
    this.stop()
  }

  play() {
    this.stop()
    if (this.slideTargets.length < 2) return
    this.timer = window.setInterval(() => this.next(), this.intervalValue)
  }

  pause() {
    this.stop()
  }

  resume() {
    if (this.element.contains(document.activeElement) || this.element.matches(":hover")) return
    this.play()
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
  }

  next() {
    this.show(this.indexValue + 1)
  }

  go(event) {
    this.show(Number(event.params.index))
    this.play()
  }

  pointerDown(event) {
    this.startX = event.clientX
  }

  pointerUp(event) {
    const delta = event.clientX - this.startX
    if (Math.abs(delta) < 40) return
    this.show(this.indexValue + (delta < 0 ? 1 : -1))
    this.play()
  }

  show(index) {
    const total = this.slideTargets.length
    if (total === 0) return

    this.indexValue = (index + total) % total
    this.slideTargets.forEach((slide, i) => {
      slide.hidden = i !== this.indexValue
    })
    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("is-active", i === this.indexValue)
    })
  }
}
